//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('checkPoints', {
//        templateUrl: 'views/components/views/checkPoints/checkPoints.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'checkPointsService', 'ttGridFactory', function ($stateParams, utilityService, checkPointsService, ttGridFactory) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                gridReady: false,
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_checkpointsComponentGrid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            async function loadSetting() {
//                vm.model.setting = (await checkPointsService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 3318,
//                    parameters: {
//                        argtype: vm.model.setting.argtype,
//                        argvalue: vm.model.setting.argvalue
//                    }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }
//        }]
//    });
//})();
